import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=aa1e7dc6&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=aa1e7dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1e7dc6",
  null
  
)

export default component.exports